import { baseURL } from "../utils/constants";
import { getAudioLanguageFromLocalStorage } from "../utils/speechUtils";
import axiosInstance from "../utils/axiosUtil";

const synthesyzeSpeechAPI = () => {
  let previousPatient: string | undefined = undefined;
  let previousDoctor: string | undefined = undefined;
  let cachedLanguage: string | undefined = undefined
  let previousBookingId: string | undefined = undefined;
  let previousRoom: string | undefined = undefined;
  let requestInProgress = false;

  return async (language: string = getAudioLanguageFromLocalStorage(), doctor: string | undefined, patient: string | undefined, bookingId: string | undefined , room?: string) => {
    if (!doctor || !patient) {
      return;
    }

    const normalizedDoctor = doctor.toLowerCase();
    const normalizedPatient = patient.toLowerCase();

    // Check if this is a duplicate call with same parameters
    const isDuplicate = normalizedPatient === previousPatient && 
                       normalizedDoctor === previousDoctor && 
                       previousBookingId === bookingId && 
                       language === cachedLanguage && 
                       room === previousRoom;

    if (isDuplicate && requestInProgress) {
      return;
    }

    // Update cache with new parameters
    if (!isDuplicate) {
      previousPatient = normalizedPatient;
      previousDoctor = normalizedDoctor;
      cachedLanguage = language;
      previousBookingId = bookingId;
      previousRoom = room;
    }

    requestInProgress = true;

    try {
      const response = await axiosInstance.post(`${baseURL}/textToSpeech/synthesize`, {
          language,
          doctor: normalizedDoctor,
          patient: normalizedPatient,
          ...(room && { room })
        }
      );
      requestInProgress = false;
      return response;
    } catch (error: any) {
      requestInProgress = false;
      if (error.response) {
        return error.response;
      } else {
        return null;
      }
    }
  };
}

export const synthesyzeSpeech  =  synthesyzeSpeechAPI()
